import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { parseLocalePath } from "@/locale/routes";
import { trackPageView } from "@/lib/analytics";

/** Сброс скролла при смене страницы (SPA). Якоря на главной — через Index / useHomeSectionNav. */
export function ScrollToTop() {
  const { pathname, hash, state } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  useEffect(() => {
    const scrollTo = (state as { scrollTo?: string } | null)?.scrollTo;
    if (scrollTo) return;

    const hashId = hash.replace(/^#/, "");
    const onHome = parseLocalePath(pathname).basePath === "/";
    if (onHome && hashId) return;

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash, state]);

  return null;
}
